// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-1743ecc8] .custom-nav-container {\n  margin-left: 20px;\n  margin-right: 20px;\n}\n[data-v-1743ecc8] .custom-nav-container .nav-item .nav-link {\n  font-size: 14px;\n  color: #3F5B60;\n  padding-right: 70px;\n  padding-left: 45px;\n}\n[data-v-1743ecc8] .custom-nav-container .nav-item .nav-link.active:after {\n  content: unset;\n}", ""]);
// Exports
module.exports = exports;
